import React, { useState, useRef } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import GetDistricts from '../../Dropdowns/getDistricts';
import CircularProgress from "@mui/material/CircularProgress";

function Port_Excel_Int() {
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [distCode, setDistCode] = useState('');
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingMonths, setLoadingMonths] = useState(false);
    const [loadingYears, setLoadingYears] = useState(false);
    const detailsRef = useRef(null);
   
    const monthNames = {
        1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun',
        7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'
    };

    const handleYearChange = (selectedYear) => {
        setYear(selectedYear);
    };

    const handleDistrictChange = (dist_code) => {
        setDistCode(dist_code);
    };

    const handleLoadingMonthsChange = (isLoading) => {
        setLoadingMonths(isLoading);
    };

    const handleLoadingYearsChange = (isLoading) => {
        setLoadingYears(isLoading);
    };

    const handleLoadingDistrictsChange = (isLoading) => {
        setLoadingDistricts(isLoading);
    };

    const detailsR = async (e) => {
        e.preventDefault();
        if (distCode == null || distCode == "" || distCode == undefined) {
            alert("Please Select District");
            return false;
        }
       
        const monthSelect = document.getElementById('month');
        const yearSelect = document.getElementById('year');
        const selectedMonth = monthSelect ? monthSelect.value : '';
        const selectedYear = yearSelect ? yearSelect.value : '';
       
        if (selectedMonth == 0 || selectedMonth == '' || selectedMonth == null) {
            alert('Please select Month');
            return false;
        }
        if (selectedYear == 0 || selectedYear == '' || selectedYear == null) {
            alert('Please select Year');
            return false;
        }
       
        setMonth(selectedMonth);
        setYear(selectedYear);
        setLoading(true);
       
        if (detailsRef.current) {
            window.scrollTo({
                top: detailsRef.current.offsetTop,
                behavior: 'smooth'
            });
        }
       
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/dist`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `month=${selectedMonth}&year=${selectedYear}&dist_code=${distCode}`,
            });
            const data = await response.json();
            if (response.ok) {
                setDetails(data);
            } else {
                setDetails([]);
            }
        } catch (error) {
            console.error('Error fetching details:', error);
            setDetails([]);
        } finally {
            setLoading(false);
        }
        return false;
    };

    const goBack = () => {
        window.history.back();
    };

    const tableToExcel = (tableHtml, filename) => {
        const uri = 'data:application/vnd.ms-excel;base64,';
        const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
        const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));
        const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p]);
        const ctx = {
            worksheet: filename.replace('.xls', ''),
            table: tableHtml
        };
        const encoded = base64(format(template, ctx));
        const link = document.createElement('a');
        link.href = uri + encoded;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handlePortInDownload = async (row) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/port-in?month=${month}&year=${year}&dist_code=${row.dist_code}&afso_code=${row.afso_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (response.ok && data.length > 0) {
                const monthNum = parseInt(month);
                const monthStr = monthNames[monthNum] || month;
                const filename = `FPS_Portability_In_${row.dist_code}_${row.afso_code}_${month}_${year}.xls`;
                let tableHtml = `
                    <table width="100%" border="1">
                        <thead>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th colspan="12">Portability Transactions</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th rowspan="2">Sl NO</th>
                                <th colspan="3"><div align="center">Availed FPS Details</div></th>
                                <th colspan="3"><div align="center">Tagged FPS Details</div></th>
                                <th rowspan="2">RC No</th>
                                <th rowspan="2">Scheme</th>
                                <th rowspan="2">Availed Member</th>
                                <th rowspan="2">Receipt Id</th>
                                <th rowspan="2">Availed Date Time</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th><div align="center">District</div></th>
                                <th><div align="center">Office</div></th>
                                <th><div align="center">FPS</div></th>
                                <th><div align="center">District</div></th>
                                <th><div align="center">Office</div></th>
                                <th><div align="center">FPS</div></th>
                            </tr>
                        </thead>
                        <tbody>
                `;
                data.forEach((item, index) => {
                    tableHtml += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.availed_dist || ''}</td>
                            <td>${item.availed_office || ''}</td>
                            <td>&nbsp;${item.port_fps_id || ''}</td>
                            <td>${item.tagged_dist || ''}</td>
                            <td>${item.tagged_office || ''}</td>
                            <td>&nbsp;${item.fps_id || ''}</td>
                            <td>&nbsp;${item.existing_rc_number || ''}</td>
                            <td>${item.scheme_short_name || ''}</td>
                            <td>${item.availed_member_name || ''}</td>
                            <td>&nbsp;${item.receipt_id || ''}</td>
                            <td>&nbsp;${item.trans_date || ''}</td>
                        </tr>
                    `;
                });
                tableHtml += `
                        </tbody>
                    </table>
                `;
                tableToExcel(tableHtml, filename);
            } else {
                alert('No Data Found');
            }
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        }
    };

    const handlePortOutDownload = async (row) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/port-out?month=${month}&year=${year}&dist_code=${row.dist_code}&afso_code=${row.afso_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (response.ok && data.length > 0) {
                const monthNum = parseInt(month);
                const monthStr = monthNames[monthNum] || month;
                const filename = `FPS_Portability_Out_${row.dist_code}_${row.afso_code}_${month}_${year}.xls`;
                let tableHtml = `
                    <table width="100%" border="1">
                        <thead>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th colspan="12">Portability Transactions</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th rowspan="2">Sl NO</th>
                                <th colspan="3"><div align="center">Tagged FPS Details</div></th>
                                <th colspan="3"><div align="center">Availed FPS Details</div></th>
                                <th rowspan="2">RC No</th>
                                <th rowspan="2">Scheme</th>
                                <th rowspan="2">Availed Member</th>
                                <th rowspan="2">Receipt Id</th>
                                <th rowspan="2">Availed Date Time</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th><div align="center">District</div></th>
                                <th><div align="center">Office</div></th>
                                <th><div align="center">FPS</div></th>
                                <th><div align="center">District</div></th>
                                <th><div align="center">Office</div></th>
                                <th><div align="center">FPS</div></th>
                            </tr>
                        </thead>
                        <tbody>
                `;
                data.forEach((item, index) => {
                    tableHtml += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.tagged_dist || ''}</td>
                            <td>${item.tagged_office || ''}</td>
                            <td>&nbsp;${item.fps_id || ''}</td>
                            <td>${item.availed_dist || ''}</td>
                            <td>${item.availed_office || ''}</td>
                            <td>&nbsp;${item.port_fps_id || ''}</td>
                            <td>&nbsp;${item.existing_rc_number || ''}</td>
                            <td>${item.scheme_short_name || ''}</td>
                            <td>${item.availed_member_name || ''}</td>
                            <td>&nbsp;${item.receipt_id || ''}</td>
                            <td>&nbsp;${item.trans_date || ''}</td>
                        </tr>
                    `;
                });
                tableHtml += `
                        </tbody>
                    </table>
                `;
                tableToExcel(tableHtml, filename);
            } else {
                alert('No Data Found');
            }
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        }
    };

    const handleOffcSalesDownload = async (row) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/offc-sales?month=${month}&year=${year}&dist_code=${row.dist_code}&afso_code=${row.afso_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const result = await response.json();
           
            if (response.ok && result.commodities && result.commodities.length > 0 && result.data && result.data.length > 0) {
                const monthNum = parseInt(month);
                const monthStr = monthNames[monthNum] || month;
                const filename = `FPS_Wise_Sales_${row.dist_code}_${row.afso_code}_${month}_${year}.xls`;
                const colSpan = 4 + result.commodities.length;
               
                let tableHtml = `
                    <table width="100%" border="1">
                        <thead>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th colspan="${colSpan}">FPS Wise Sales for <font style="color: orange;">${monthStr}</font>-<font style="color: orange;">${year}</font></th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th rowspan="2">Sl.No</th>
                                <th rowspan="2">District</th>
                                <th rowspan="2">Block</th>
                                <th rowspan="2">FPS Id</th>
                                <th colspan="${result.commodities.length}">Sale.Commodity</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                `;
               
                result.commodities.forEach(comm => {
                    tableHtml += `<th>${comm.comm_short || ''}<br />( ${comm.unit_type || ''} )</th>`;
                });
               
                tableHtml += `
                            </tr>
                        </thead>
                        <tbody>
                `;
               
                result.data.forEach((dataRow, index) => {
                    tableHtml += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${dataRow.dist_name_en || ''}</td>
                            <td>${dataRow.afso_name_en || ''}</td>
                            <td>${dataRow.fps_id || ''}</td>
                    `;
                    result.commodities.forEach(comm => {
                        const val = dataRow[`comm_${comm.comm_code}`] || 0;
                        tableHtml += `<td align="right">${parseFloat(val).toFixed(3)}</td>`;
                    });
                    tableHtml += `</tr>`;
                });
               
                tableHtml += `
                        </tbody>
                        <tfoot>
                            <tr class="tableheader">
                                <th colspan="4">Total</th>
                    `;
               
                result.commodities.forEach(comm => {
                    const val = result.total[`comm_${comm.comm_code}`] || 0;
                    tableHtml += `<th align="right">${parseFloat(val).toFixed(3)}</th>`;
                });
               
                tableHtml += `
                            </tr>
                        </tfoot>
                    </table>
                `;
               
                tableToExcel(tableHtml, filename);
            } else {
                alert('No Sales Data Found');
            }
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        }
    };

    const handleOffcAlotSalesDownload = async (row) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/offc-alot-sales?month=${month}&year=${year}&dist_code=${row.dist_code}&afso_code=${row.afso_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const result = await response.json();
           
            if (response.ok && result.commodities && result.commodities.length > 0 && result.data && result.data.length > 0) {
                const monthNum = parseInt(month);
                const monthStr = monthNames[monthNum] || month;
                const filename = `FPS_Wise_Allotted_Sales_${row.dist_code}_${row.afso_code}_${month}_${year}.xls`;
                const colSpan = 4 + (result.commodities.length * 2);
               
                let tableHtml = `
                    <table width="100%" border="1">
                        <thead>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th colspan="${colSpan}">FPS Wise Allotted Sales for <font style="color: orange;">${monthStr}</font>-<font style="color: orange;">${year}</font></th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th rowspan="4">Sl.No</th>
                                <th rowspan="4">District</th>
                                <th rowspan="4">Block</th>
                                <th rowspan="4">FPS Id</th>
                                <th colspan="${colSpan - 4}">Sales</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                `;
               
                result.groups.forEach(group => {
                    tableHtml += `<th colspan="${group.comm_size * 2}">${group.alot_month || ''} / ${group.alot_year || ''}</th>`;
                });
               
                tableHtml += `
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                `;
               
                result.commodities.forEach(comm => {
                    tableHtml += `<th colspan="2">${comm.comm_short || ''}</th>`;
                });
               
                tableHtml += `
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                `;
               
                result.commodities.forEach(comm => {
                    tableHtml += `<th>Issued<br/>Cards</th><th>Qty in <br/>( ${comm.unit_type || ''} )</th>`;
                });
               
                tableHtml += `
                            </tr>
                        </thead>
                        <tbody>
                `;
               
                result.data.forEach((dataRow, index) => {
                    tableHtml += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${dataRow.dist_name_en || ''}</td>
                            <td>${dataRow.afso_name_en || ''}</td>
                            <td>${dataRow.fps_id || ''}</td>
                    `;
                   
                    result.commodities.forEach(comm => {
                        const code = comm.comm_code;
                        const alotM = comm.alot_month;
                        const alotY = comm.alot_year;
                        const cardsVal = dataRow[`cards_${code}_${alotM}_${alotY}`] || 0;
                        const commVal = dataRow[`comm_${code}_${alotM}_${alotY}`] || 0;
                        tableHtml += `<td align="right">${parseFloat(cardsVal).toFixed(3)}</td><td align="right">${parseFloat(commVal).toFixed(3)}</td>`;
                    });
                   
                    tableHtml += `</tr>`;
                });
               
                tableHtml += `
                        </tbody>
                        <tfoot>
                            <tr class="tableheader">
                                <th colspan="4">Total</th>
                    `;
               
                result.commodities.forEach(comm => {
                    const code = comm.comm_code;
                    const alotM = comm.alot_month;
                    const alotY = comm.alot_year;
                    const cardsVal = result.total[`cards_${code}_${alotM}_${alotY}`] || 0;
                    const commVal = result.total[`comm_${code}_${alotM}_${alotY}`] || 0;
                    tableHtml += `<th align="right">${parseFloat(cardsVal).toFixed(3)}</th><th align="right">${parseFloat(commVal).toFixed(3)}</th>`;
                });
               
                tableHtml += `
                            </tr>
                        </tfoot>
                    </table>
                `;
               
                tableToExcel(tableHtml, filename);
            } else {
                alert('No Allotted Sales Data Found');
            }
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        }
    };

    const handleFpsDetailsDownload = async (row) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/portexcel/fps-details?month=${month}&year=${year}&dist_code=${row.dist_code}&afso_code=${row.afso_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
           
            if (response.ok && data.length > 0) {
                const monthNum = parseInt(month);
                const monthStr = monthNames[monthNum] || month;
                const filename = `FPS_Details_${row.dist_code}_${row.afso_code}_${month}_${year}.xls`;
               
                let tableHtml = `
                    <table width="100%" border="1">
                        <thead>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th colspan="12">FPS details for ${monthStr}'${year}</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th rowspan="2">Sl No</th>
                                <th rowspan="2">District</th>
                                <th rowspan="2">Office</th>
                                <th rowspan="2">FPS Id</th>
                                <th rowspan="2">FPS Name</th>
                                <th rowspan="2">Device Id</th>
                                <th colspan="2">Dealer</th>
                                <th colspan="2">Nominee 1</th>
                                <th colspan="2">Nominee 2</th>
                            </tr>
                            <tr bgcolor="#ff9900" style="font-weight: bold; color: black; background-color: #ff9900;" align="center">
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Name</th>
                                <th>Mobile</th>
                            </tr>
                        </thead>
                        <tbody>
                `;
               
                data.forEach((item, index) => {
                    tableHtml += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.dist_name_en || ''}</td>
                            <td>${item.afso_name_en || ''}</td>
                            <td>&nbsp;${item.fps_id || ''}</td>
                            <td>${item.fps_name_en || ''}</td>
                            <td>&nbsp;${item.device_id || ''}</td>
                            <td>${item.del_name || ''}</td>
                            <td>&nbsp;${item.del_mob || ''}</td>
                            <td>${item.nom_1_name || ''}</td>
                            <td>&nbsp;${item.nom_1_mob || ''}</td>
                            <td>${item.nom_2_name || ''}</td>
                            <td>&nbsp;${item.nom_2_mob || ''}</td>
                        </tr>
                    `;
                });
               
                tableHtml += `
                        </tbody>
                    </table>
                `;
               
                tableToExcel(tableHtml, filename);
            } else {
                alert('No FPS Details Found');
            }
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error downloading Excel');
        }
    };

    if (details && details.length === 0) {
        return (
            <div>
                <table width="50%" align="center" style={{ marginBottom: "15px", marginTop: "15px" }}>
                    <tbody>
                        <tr className="tableheader">
                            <th colSpan="8">FPS Details / Sales / Portability Excel Download</th>
                        </tr>
                        <tr>
                            <td>Sale Month</td>
                            <td>
                                <GetMonths
                                    input_id="month"
                                    onLoadingChange={handleLoadingMonthsChange}
                                />
                            </td>
                            <td>Sale Year</td>
                            <td>
                                <GetYears
                                    input_id="year"
                                    onChange={handleYearChange}
                                    onLoadingChange={handleLoadingYearsChange}
                                />
                            </td>
                            <td>District</td>
                            <td>
                                <GetDistricts
                                    onLoadingChange={handleLoadingDistrictsChange}
                                    onChange={handleDistrictChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="8" align="center">
                                <button onClick={detailsR} className="button button2" style={{ marginRight: "7px" }}>Submit</button>
                                <button onClick={goBack} className="button button2">Back</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div align="center" id="loadingR" style={{ display: loading ? "block" : "none" }}>
                    <CircularProgress />
                </div>
                <br />
                <div ref={detailsRef} id="detailsR" align="center">
                    <div className="mainhead">No Data Found</div>
                </div>
                <br /><br /><br /><br />
            </div>
        );
    }

    return (
        <div>
            <table width="50%" align="center" style={{ marginBottom: "15px", marginTop: "15px" }}>
                <tbody>
                    <tr className="tableheader">
                        <th colSpan="8">FPS Details / Sales / Portability Excel Download</th>
                    </tr>
                    <tr>
                        <td>Sale Month</td>
                        <td>
                            <GetMonths
                                input_id="month"
                                onLoadingChange={handleLoadingMonthsChange}
                            />
                        </td>
                        <td>Sale Year</td>
                        <td>
                            <GetYears
                                input_id="year"
                                onChange={handleYearChange}
                                onLoadingChange={handleLoadingYearsChange}
                            />
                        </td>
                        <td>District</td>
                        <td>
                            <GetDistricts
                                onLoadingChange={handleLoadingDistrictsChange}
                                onChange={handleDistrictChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="8" align="center">
                            <button onClick={detailsR} className="button button2" style={{ marginRight: "7px" }}>Submit</button>
                            <button onClick={goBack} className="button button2">Back</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div align="center" id="loadingR" style={{ display: loading ? "block" : "none" }}>
                <CircularProgress />
            </div>
            <br />
            {details && details.length > 0 && (
                <div ref={detailsRef} id="detailsR" align="center">
                    <table align="center" width="60%" border="1">
                        <tr className="tableheader">
                            <td colSpan="7">Office Wise FPS Details / Sales / Portability for {details[0].dist_name_en}</td>
                        </tr>
                        <tr className="tableheader">
                            <td>Sl No</td>
                            <td>Office</td>
                            <td>Portability<br/>In</td>
                            <td>Portability<br/>Out</td>
                            <td>Cumulative<br/>Sales</td>
                            <td>Allotted<br/>Month Wise<br/>Sales</td>
                            <td>FPS<br/>Details</td>
                        </tr>
                        {details.map((row, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.afso_name_en}</td>
                                <td align="center">
                                    <button
                                        onClick={() => handlePortInDownload(row)}
                                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                            onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                            style={{
                                                fontSize: "15px",
                                                fontWeight: "bold",
                                                color: "blue",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                textDecoration: "none"
                                            }}
                                        >
                                            Excel
                                        </button>
                                </td>
                                <td align="center">
                                    <button
                                        onClick={() => handlePortOutDownload(row)}
                                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "blue",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Excel
                                    </button>
                                </td>
                                <td align="center">
                                    <button
                                        onClick={() => handleOffcSalesDownload(row)}
                                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "blue",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Excel
                                    </button>
                                </td>
                                <td align="center">
                                    <button
                                        onClick={() => handleOffcAlotSalesDownload(row)}
                                       onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "blue",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Excel
                                    </button>
                                </td>
                                <td align="center">
                                    <button
                                        onClick={() => handleFpsDetailsDownload(row)}
                                        onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                                        onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                                        style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "blue",
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Excel
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </table>
                </div>
            )}
            <br /><br /><br /><br />
            <br></br><br></br>
        </div>
    );
}

export default Port_Excel_Int;

